import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["Component"],
  _excluded2 = ["Component"],
  _excluded3 = ["Component"],
  _excluded4 = ["Component"],
  _excluded5 = ["Component"],
  _excluded6 = ["Component"],
  _excluded7 = ["Component"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { isEmpty } from 'lodash';
import React from 'react';
import { BackButton } from "../../../HeaderButtons/BackButton/BackButton";
import { LoginButton as _LoginButton } from "../../../HeaderButtons/LoginButton";
import { LogoButton } from "../../../HeaderButtons/LogoButton/LogoButton";
import { ModalLayout } from "./components/ModalLayout/ModalLayoutDesktop";
import { Input as _Input } from "../../../../../components/Input";
import { Toggle } from "./components/PaymentDetailsSection/Toggle";
import { Button } from "./components/PaymentMethodSection/Button";
import { Option } from "./components/PaymentMethodSection/Option";
import { PaymentLayout } from "./components/PaymentMethodSection/PaymentLayout";
import { Circle } from "./components/PaymentMethodSection/PaymentOption/Circle";
import styles from "./styles.pcss";
import { ChangePaymentTypeButton } from "./components/PaymentDetailsSection/InputSection/components/ChangePaymentTypeButton/ChangePaymentTypeButton";
import { SumInput } from "./components/PaymentDetailsSection/InputSection/components/SumInput/SumInput";
var cn = classNames.bind(styles);
export var PaymentSelection = function PaymentSelection(_ref) {
  var _props;
  var _ref$modalProps = _ref.modalProps,
    _ref$modalProps$Compo = _ref$modalProps.Component,
    ModalLayoutComponent = _ref$modalProps$Compo === void 0 ? ModalLayout : _ref$modalProps$Compo,
    modalProps = _objectWithoutProperties(_ref$modalProps, _excluded),
    _ref$headerProps = _ref.headerProps,
    _ref$headerProps$clos = _ref$headerProps.closeButtonProps,
    _ref$headerProps$clos2 = _ref$headerProps$clos.Component,
    CloseButton = _ref$headerProps$clos2 === void 0 ? BackButton : _ref$headerProps$clos2,
    closeButtonProps = _objectWithoutProperties(_ref$headerProps$clos, _excluded2),
    _ref$headerProps$logo = _ref$headerProps.logoProps.Component,
    LogoComponent = _ref$headerProps$logo === void 0 ? LogoButton : _ref$headerProps$logo,
    _ref$headerProps$logi = _ref$headerProps.loginButtonProps,
    _ref$headerProps$logi2 = _ref$headerProps$logi.Component,
    LoginButton = _ref$headerProps$logi2 === void 0 ? _LoginButton : _ref$headerProps$logi2,
    loginButtonProps = _objectWithoutProperties(_ref$headerProps$logi, _excluded3),
    _ref$inputSectionProp = _ref.inputSectionProps,
    _ref$inputSectionProp2 = _ref$inputSectionProp.phoneInputProps,
    _ref$inputSectionProp3 = _ref$inputSectionProp2.Component,
    PhoneInputComponent = _ref$inputSectionProp3 === void 0 ? _Input : _ref$inputSectionProp3,
    phoneInputProps = _objectWithoutProperties(_ref$inputSectionProp2, _excluded4),
    _ref$inputSectionProp4 = _ref$inputSectionProp.sumInputProps,
    _ref$inputSectionProp5 = _ref$inputSectionProp4.Component,
    SumInputComponent = _ref$inputSectionProp5 === void 0 ? SumInput : _ref$inputSectionProp5,
    sumInputProps = _objectWithoutProperties(_ref$inputSectionProp4, _excluded5),
    toggleProps = _ref$inputSectionProp.toggleProps,
    changePaymentTypeButtonProps = _ref$inputSectionProp.changePaymentTypeButtonProps,
    _ref$paymentSectionPr = _ref.paymentSectionProps,
    _ref$paymentSectionPr2 = _ref$paymentSectionPr.paymentOptionProps,
    _ref$paymentSectionPr3 = _ref$paymentSectionPr2 === void 0 ? {} : _ref$paymentSectionPr2,
    _ref$paymentSectionPr4 = _ref$paymentSectionPr3.Component,
    PaymentOptionComponent = _ref$paymentSectionPr4 === void 0 ? Option : _ref$paymentSectionPr4,
    paymentOptionProps = _objectWithoutProperties(_ref$paymentSectionPr3, _excluded6),
    _ref$paymentSectionPr5 = _ref$paymentSectionPr.quickPaymentOptionProps,
    _ref$paymentSectionPr6 = _ref$paymentSectionPr5 === void 0 ? {} : _ref$paymentSectionPr5,
    _ref$paymentSectionPr7 = _ref$paymentSectionPr6.Component,
    FastPaymentOptionComponent = _ref$paymentSectionPr7 === void 0 ? Option : _ref$paymentSectionPr7,
    fastPaymentOptionProps = _objectWithoutProperties(_ref$paymentSectionPr6, _excluded7),
    paymentButtonProps = _ref$paymentSectionPr.paymentButtonProps,
    conditions = _ref.conditions;
  var PaymentButtonComponent = (paymentButtonProps === null || paymentButtonProps === void 0 ? void 0 : paymentButtonProps.Component) || Button;
  return /*#__PURE__*/React.createElement(ModalLayoutComponent, _extends({}, modalProps, {
    "data-t-id": "components-PaymentSelection"
  }), /*#__PURE__*/React.createElement(ModalLayoutComponent.Header, null, /*#__PURE__*/React.createElement(CloseButton, closeButtonProps), /*#__PURE__*/React.createElement(LogoComponent, null), /*#__PURE__*/React.createElement(LoginButton, loginButtonProps)), /*#__PURE__*/React.createElement(ModalLayoutComponent.Inputs, null, /*#__PURE__*/React.createElement(PhoneInputComponent, phoneInputProps), changePaymentTypeButtonProps && /*#__PURE__*/React.createElement(ChangePaymentTypeButton, changePaymentTypeButtonProps), /*#__PURE__*/React.createElement(SumInputComponent, sumInputProps)), /*#__PURE__*/React.createElement(ModalLayoutComponent.Bonus, null, toggleProps.map(function (props) {
    return /*#__PURE__*/React.createElement(Toggle, props) // Апельсинки
    ;
  })), /*#__PURE__*/React.createElement(ModalLayoutComponent.Payments, null, !isEmpty(fastPaymentOptionProps) && /*#__PURE__*/React.createElement(PaymentLayout, fastPaymentOptionProps, fastPaymentOptionProps === null || fastPaymentOptionProps === void 0 || (_props = fastPaymentOptionProps.props) === null || _props === void 0 ? void 0 : _props.map(function (props) {
    return /*#__PURE__*/React.createElement(FastPaymentOptionComponent, _extends({}, props, {
      key: props.id,
      rightComponentProps: _objectSpread(_objectSpread({}, props.rightComponentProps), {}, {
        Component: Circle
      })
    }));
  })), !isEmpty(paymentOptionProps) && /*#__PURE__*/React.createElement(PaymentLayout, paymentOptionProps, paymentOptionProps === null || paymentOptionProps === void 0 ? void 0 : paymentOptionProps.props.map(function (props) {
    return /*#__PURE__*/React.createElement(PaymentOptionComponent, _extends({}, props, {
      key: props.id,
      rightComponentProps: _objectSpread(_objectSpread({}, props.rightComponentProps), {}, {
        Component: Circle
      })
    }));
  }))), /*#__PURE__*/React.createElement(ModalLayoutComponent.Button, null, !isEmpty(paymentButtonProps) && /*#__PURE__*/React.createElement(PaymentButtonComponent, _extends({}, paymentButtonProps, {
    width: "full"
  })), !isEmpty(conditions) && /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    lineHeight: 16,
    size: 12
  }, conditions.map(function (c) {
    var _c$children;
    if (typeof c === 'string') return c;
    return /*#__PURE__*/React.createElement(Text, _extends({}, c, {
      className: cn('link'),
      color: "primary",
      key: (_c$children = c.children) === null || _c$children === void 0 ? void 0 : _c$children.toString(),
      lineHeight: 16,
      size: 12,
      tagName: "a"
    }));
  }))));
};